import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCode, FiArchive, FiHome } = FiIcons;

function Header({ showBackButton, onBackToHome }) {
  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white shadow-sm border-b border-slate-200"
    >
      <div className="container mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2">
              <SafeIcon icon={FiArchive} className="text-2xl text-blue-600" />
              <SafeIcon icon={FiCode} className="text-2xl text-slate-600" />
            </div>
            <div>
              <h1 className="text-2xl font-bold text-slate-800">Code File Analyzer</h1>
              <p className="text-slate-600">Upload zip files and convert code to structured text format</p>
            </div>
          </div>
          
          {showBackButton && (
            <motion.button
              onClick={onBackToHome}
              className="flex items-center space-x-2 px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-800 hover:bg-slate-100 rounded-lg transition-colors"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <SafeIcon icon={FiHome} className="text-lg" />
              <span>Back to Home</span>
            </motion.button>
          )}
        </div>
      </div>
    </motion.header>
  );
}

export default Header;